var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ChainId, NATIVE_ADDRESS, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { WrappedNativeTokens } from '@shared/types/quoting-engine/wrappedNativeTokens';
import { getEthAmount } from '../SingleAssetHeader';
import { toSpecialFixed } from '@/lib/misc/utils';
import { SOLANA_NATIVE_SIMPLE } from '@/lib/asset/nativeAddressHelper';
export var confirmationString = function (fromAssets, toAssets, amount) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    amount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) == 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) == 1) {
        return "You are about to swap  ".concat(toSpecialFixed(getEthAmount(fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0])).value, " ").concat((_a = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _a === void 0 ? void 0 : _a.contract_ticker_symbol, " (").concat((_c = (_b = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _b === void 0 ? void 0 : _b.amountToUse) === null || _c === void 0 ? void 0 : _c.toFixed(2), " USD) to ").concat((_d = toAssets === null || toAssets === void 0 ? void 0 : toAssets[0]) === null || _d === void 0 ? void 0 : _d.contract_ticker_symbol);
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) > 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) == 1) {
        var string_1 = 'You are about to swap ';
        fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_1 += "".concat((_a = toSpecialFixed(getEthAmount(assetItem))) === null || _a === void 0 ? void 0 : _a.value, " ").concat(assetItem.contract_ticker_symbol, " (").concat((_b = assetItem.amountToUse) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== fromAssets.length - 1) {
                string_1 += 'and ';
            }
        });
        return (string_1 += "to ".concat((_e = toAssets === null || toAssets === void 0 ? void 0 : toAssets[0]) === null || _e === void 0 ? void 0 : _e.contract_ticker_symbol));
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) == 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) > 1) {
        var string_2 = "You are about to swap  ".concat((_f = getEthAmount(fromAssets[0])) === null || _f === void 0 ? void 0 : _f.toFixed(4), " ").concat((_g = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets[0]) === null || _g === void 0 ? void 0 : _g.contract_ticker_symbol, " (").concat((_h = fromAssets[0].amountToUse) === null || _h === void 0 ? void 0 : _h.toFixed(2), " USD) for ").concat(toAssets === null || toAssets === void 0 ? void 0 : toAssets.length, " tokens, split into a ratio of ");
        toAssets === null || toAssets === void 0 ? void 0 : toAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_2 += "".concat((_a = toSpecialFixed(assetItem.percentage, 2)) === null || _a === void 0 ? void 0 : _a.value, "% ").concat(assetItem.contract_ticker_symbol, " (~").concat((_b = ((assetItem.percentage / 100) * amount)) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== toAssets.length - 1) {
                string_2 += 'and ';
            }
        });
        return string_2;
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) > 1 && (toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) > 1) {
        var string_3 = 'You are about to swap ';
        fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_3 += "".concat((_a = getEthAmount(assetItem)) === null || _a === void 0 ? void 0 : _a.toFixed(4), " ").concat(assetItem.contract_ticker_symbol, " (").concat((_b = assetItem.amountToUse) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== fromAssets.length - 1) {
                string_3 += 'and ';
            }
        });
        string_3 += "for ".concat(toAssets === null || toAssets === void 0 ? void 0 : toAssets.length, " tokens, split into a ratio of ");
        toAssets === null || toAssets === void 0 ? void 0 : toAssets.forEach(function (assetItem, index) {
            var _a, _b;
            string_3 += "".concat((_a = toSpecialFixed(assetItem.percentage, 2)) === null || _a === void 0 ? void 0 : _a.value, "% ").concat(assetItem.contract_ticker_symbol, " (~").concat((_b = ((assetItem.percentage / 100) * amount)) === null || _b === void 0 ? void 0 : _b.toFixed(2), " USD) ");
            if (index !== toAssets.length - 1) {
                string_3 += 'and ';
            }
        });
        return string_3;
    }
    return '';
};
var truncateError = function (error) {
    if (error.length > 100) {
        return error.slice(0, 100) + '...';
    }
    else {
        return error;
    }
};
export var quoteString = function (quoteDataInput, priceData) {
    var _a, _b, _c, _d;
    if (quoteDataInput === null || quoteDataInput === void 0 ? void 0 : quoteDataInput.error) {
        return {
            error: quoteDataInput.error,
            message: truncateError(quoteDataInput.error),
        };
    }
    //quote is single chain (first scenario) and quote is multi chain (second scenario)
    var quoteData = (_a = quoteDataInput === null || quoteDataInput === void 0 ? void 0 : quoteDataInput.response) === null || _a === void 0 ? void 0 : _a[0];
    if (!quoteData || !(priceData === null || priceData === void 0 ? void 0 : priceData.length)) {
        return null;
    }
    try {
        var price_1 = quoteData.price, quote = quoteData.quote, fees = quoteData.fees;
        console.log("WUJI PRICE_IN_STRING", price_1, quote, fees);
        console.log('WUJI PRICEDATA', priceData);
        // Handle cross-chain (DLN) swaps
        var tokenOutInfo_1 = quote.tokenOut;
        var formattedAmount = parseFloat(quote.amountOut) / Math.pow(10, tokenOutInfo_1.decimals);
        var priceInfo = priceData.find(function (x) {
            var _a, _b, _c, _d, _e, _f, _g;
            if ((tokenOutInfo_1 === null || tokenOutInfo_1 === void 0 ? void 0 : tokenOutInfo_1.address) === ZERO_ADDRESS ||
                ((_a = tokenOutInfo_1 === null || tokenOutInfo_1 === void 0 ? void 0 : tokenOutInfo_1.address) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (NATIVE_ADDRESS === null || NATIVE_ADDRESS === void 0 ? void 0 : NATIVE_ADDRESS.toLowerCase())) {
                return (((_c = (_b = x === null || x === void 0 ? void 0 : x.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()) ===
                    ((_d = WrappedNativeTokens.get(price_1.networkOut ||
                        price_1.network)) === null || _d === void 0 ? void 0 : _d.toLowerCase()));
            }
            else {
                return ((_f = (_e = x === null || x === void 0 ? void 0 : x.token) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === ((_g = tokenOutInfo_1.address) === null || _g === void 0 ? void 0 : _g.toLowerCase());
            }
        });
        console.log('WUJI priceInfo', priceInfo, priceData, tokenOutInfo_1);
        var usdPrice = priceInfo ? parseFloat((_d = (_c = (_b = priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.prices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.priceUsd) === null || _d === void 0 ? void 0 : _d.toString()) : 0;
        if (usdPrice === 0) {
            return {
                error: 'Error fetching price data',
                message: 'Error fetching quote. Please try adjusting your slippage or asset amounts',
            };
        }
        var usdValue = formattedAmount * usdPrice;
        return [
            {
                address: tokenOutInfo_1.address,
                amount: quote.amountOut,
                network: quote.networkOut,
                aggregator: quoteData.bridge,
                usdValue: usdValue,
                formattedAmount: formattedAmount,
                usdPrice: usdPrice,
                geniusFee: fees.swapFeeUsd,
            },
        ];
    }
    catch (e) {
        console.log('quoteStringError', e);
        return {
            message: 'Error fetching quote. Please try adjusting your slippage or asset amounts',
            error: e.message,
        };
    }
};
export var validate = function (fromAssets, toAssets) {
    var customError;
    var inputNetworks = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.map(function (x) { return x.network; });
    var outputNetworks = toAssets === null || toAssets === void 0 ? void 0 : toAssets.map(function (x) { return x.network; });
    var uniqueNetworks = __spreadArray(__spreadArray([], inputNetworks, true), outputNetworks, true).filter(function (x, i, a) { return a.indexOf(x) === i; });
    var totalUsdValue = fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.reduce(function (acc, asset) { return acc + (asset === null || asset === void 0 ? void 0 : asset.amountToUse); }, 0);
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { return toAssets.some(function (x) { return x.contract_address === asset.contract_address; }); })) {
        return {
            valid: false,
            error: 'The same asset cannot be swapped for itself',
        };
    }
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { return !asset.amountToUse || asset.amountToUse === '0'; })) {
        return {
            valid: false,
            error: '',
        };
    }
    if ((uniqueNetworks === null || uniqueNetworks === void 0 ? void 0 : uniqueNetworks.length) > 1 && totalUsdValue < 75) {
        if ((inputNetworks === null || inputNetworks === void 0 ? void 0 : inputNetworks.includes(ChainId.ETHEREUM)) || (outputNetworks === null || outputNetworks === void 0 ? void 0 : outputNetworks.includes(ChainId.ETHEREUM))) {
            if (totalUsdValue < 50) {
                return {
                    valid: false,
                    error: 'Order value must be at least $50 for cross-chain swaps using Ethereum',
                };
            }
        }
        else {
            if (totalUsdValue < 5) {
                return {
                    valid: false,
                    error: 'Order value must be at least $5 for cross-chain swaps.',
                };
            }
        }
    }
    if ((inputNetworks === null || inputNetworks === void 0 ? void 0 : inputNetworks.includes(ChainId.ETHEREUM)) && totalUsdValue < 20) {
        return {
            valid: false,
            error: 'Order value must be at least $20 on Ethereum due to gas prices.',
        };
    }
    if ((fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.length) === 0) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    if ((toAssets === null || toAssets === void 0 ? void 0 : toAssets.length) === 0) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    //if all from assets are 0
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.every(function (asset) { return asset.amountToUse === 0; })) {
        return {
            valid: false,
            error: 'Swap',
        };
    }
    //if amount to use in fromasset is greater than balance
    if (fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) { var _a, _b; return parseFloat((_a = asset.amountToUse) === null || _a === void 0 ? void 0 : _a.toFixed(1)) > parseFloat((_b = asset.usd_value) === null || _b === void 0 ? void 0 : _b.toFixed(1)) * 1.03; })) {
        return {
            valid: false,
            error: 'Amount higher than balance',
        };
    }
    //if from asset contract address included 0xeee amountToUse has to be less to have atleast 0.001
    var cutoff;
    var tokenName;
    var cutoffString;
    if (
    //TODO refactor this is a mess
    fromAssets === null || fromAssets === void 0 ? void 0 : fromAssets.some(function (asset) {
        var _a;
        if (((_a = asset.contract_address) === null || _a === void 0 ? void 0 : _a.includes('0xeeee')) ||
            asset.contract_address == ZERO_ADDRESS ||
            ((asset === null || asset === void 0 ? void 0 : asset.contract_address) == 'So11111111111111111111111111111111111111112' &&
                asset.contract_name == 'Solana') ||
            (asset === null || asset === void 0 ? void 0 : asset.contract_address) == SOLANA_NATIVE_SIMPLE) {
            console.log('error from asset -------->', asset);
            var calculatedAmount = asset.usd_value - asset.amountToUse;
            console.log('calculatedAmount -------->', calculatedAmount);
            if (asset.network === ChainId.ETHEREUM) {
                cutoff = 10;
                cutoffString = '10 dollars';
                tokenName = 'Ethereum';
                customError = "".concat(cutoffString, " of ").concat(tokenName, " will be reserved for gas fees and not used in your order.");
                return calculatedAmount < cutoff;
            }
            else if (asset.network == ChainId.SOLANA || asset.network == ChainId.SOLANA_DLN) {
                if (toAssets.some(function (x) { return x.network != ChainId.SOLANA; })) {
                    //need to reserve 5 dollars for DLN crosschain fees
                    cutoff = 5;
                    cutoffString = '5 dollars';
                    tokenName = 'Solana';
                    customError = "A portion of your ".concat(tokenName, " (~$5) will be reserved for cross-chain fees, a portion may not be used in your order.");
                    return calculatedAmount < cutoff;
                }
                else {
                    cutoff = 1;
                    cutoffString = 'One dollar';
                    tokenName = 'Solana';
                    customError = "A small portion of your ".concat(tokenName, " (~$1) will be reserved for gas fees and not used in your order.");
                    return calculatedAmount < cutoff;
                }
            }
            else {
                if (asset.network == ChainId.AVALANCHE) {
                    tokenName = 'Avalanche';
                }
                else if (asset.network == ChainId.POLYGON) {
                    tokenName = 'Matic';
                }
                else if (asset.network == ChainId.BSC) {
                    tokenName = 'BnB';
                }
                else {
                    tokenName = 'Ethereum';
                }
                if (toAssets.some(function (x) { return x.network == ChainId.SOLANA; })) {
                    //need to reserve 5 dollars for DLN crosschain fees
                    cutoff = 5;
                    cutoffString = '5 dollars';
                    customError = "A portion of your ".concat(tokenName, " (~$5) will be reserved for cross-chain fees, a portion may not be used in your order.");
                }
                else {
                    cutoff = 1;
                    cutoffString = 'A dollar';
                    customError = "A small portion of your ".concat(tokenName, " (~$1) will be reserved for gas fees and not used in your order.");
                }
                return calculatedAmount < cutoff;
            }
        }
    })) {
        console.log('wefiohwf wefwrf', customError);
        return {
            valid: true,
            error: '',
            customError: customError,
        };
    }
    return {
        valid: true,
        error: '',
    };
};
